// extracted by mini-css-extract-plugin
module.exports = {"NotifyContianer":"notify_NotifyContianer__pCgE4"};